import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServicioService} from 'app/services/servicio.services';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { Session } from 'protractor';

@Component({
  selector: 'app-mi-cuenta',
  templateUrl: './mi-cuenta.component.html',
  styleUrls: ['./mi-cuenta.component.css']
})
export class MiCuentaComponent implements OnInit {

  constructor(private _servicios: ServicioService, private _router: Router) { }
  public Cliente : any;
  private oldPassword: any;
  private newPassword: any;
  private conPassword: any;
  public hide: any = true;
  passwordForm = new FormGroup({
    foldpassword: new FormControl("",Validators.required),
    fpassword: new FormControl("",[Validators.required, Validators.minLength(6)]),
    fpasswordc: new FormControl("",[Validators.required, Validators.minLength(6)])
  });
  ngOnInit() {
    if(sessionStorage.getItem("token")== null){
      this._router.navigateByUrl("login");
    }
    this.obtenerCliente();
    //console.log(this.Cliente);
  }

  obtenerCliente(){
    this._servicios.obtenerDatosCliente(sessionStorage.getItem("cliente")).subscribe(
      result =>{
        this.Cliente = result;
        console.log(this.Cliente);
      }, error => {
        
        this._router.navigateByUrl("login");
    });
  }

  updatecliente(e){
    e.preventDefault();
    console.log(e);
    console.log("test")
    if(this.oldPassword != this.newPassword){
      if(this.newPassword == this.conPassword){
        swal({
          title: 'Contraseña Actualizada.',
          type: 'success',
        })
      }else{
        this.validar("newDistintas");
      }
    }else{
      this.validar("oldIguales");
    }

  }

  cambiarContrasena(){
    if(this.hide == false){
      this.hide = true;
    }else{
      this.hide = false;
    }
  }


  validar(opc: any){
    switch (opc){
      case "oldIguales":
        swal({
          title: 'La contraseña Anterior debe ser diferente a la nueva.',
          type: 'warning',
        })
      break;
      case "newDistintas":
        swal({
          title: 'La nueva contraseña no coincide con la confirmación.',
          type: 'warning',
        })
      break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/mi-cuenta/mi-cuenta.component.ts